export { default } from "./PartnerCard";
export * from "./PartnerCard";
